import React from "react";
import SearchHeader from "./SearchHeader";
import ChatHistorySidebar from "./ChatHistorySidebar";
import { MANUAL_URL } from "../../../shared/utils/externalLinks";

export default function SearchAppLayout({
  user,
  showSidebar,
  setShowSidebar,
  onLoadSearch,
  onNewSession,
  isMobile,
  currentSearchId,
  historyRefreshKey,
  children,
}) {
  return (
    <div className="h-screen bg-gray-50 flex overflow-hidden">
      {user && (
        <ChatHistorySidebar
          isOpen={showSidebar}
          setIsOpen={setShowSidebar}
          onLoadSearch={onLoadSearch}
          onNewSession={onNewSession}
          isMobile={isMobile}
          currentSearchId={currentSearchId}
          refreshKey={historyRefreshKey}
        />
      )}

      <div className="flex-1 flex flex-col overflow-hidden">
        <SearchHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          showSidebar={showSidebar}
          manualUrl={MANUAL_URL}
        />

        {children}
      </div>
    </div>
  );
}
